import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Content = ({ className, children, ...attributes }: Props) => {
    return (
        <div
            className={cn("tw:grow tw:p-4 tw:overflow-auto", className)}
            {...attributes}
        >
            {children}
        </div>
    );
};
